import classNames from "classnames";
import { BsXOctagonFill } from "react-icons/bs";
import { useRemovePhotoMutation } from "../store";

const Photo = ({ className, children }) => {
  const classes = classNames("photo", className);

  const [removePhoto, results] = useRemovePhotoMutation();
  const handleDeletePhoto = (e) => {
    removePhoto(children);
  };

  return (
    <div
      onClick={handleDeletePhoto}
      className="relative w-52 max-h-36 group hover:cursor-pointer"
    >
      <div className="absolute hidden group-hover:flex w-full h-full flex flex-row justify-center items-center z-10">
        {results.isLoading ? <span>...</span> : <BsXOctagonFill className=""></BsXOctagonFill>}
      </div>
      <img
        className={`${classes} group-hover:opacity-50`}
        // src="https://uomdai19172.files.wordpress.com/2019/11/sea5.jpg?w=1024"
        src={children.url}
        alt={children.url}
      ></img>
    </div>
  );
};

export default Photo;
